export const MonthsEnum = [
  {
    value: 'JAN',
    label: 'JAN',
  },
  {
    value: 'FEB',
    label: 'FEB',
  },
  {
    value: 'MAR',
    label: 'MAR',
  },
  {
    value: 'APR',
    label: 'APR',
  },
  {
    value: 'MAY',
    label: 'MAY',
  },
  {
    value: 'JUN',
    label: 'JUN',
  },
  {
    value: 'JUL',
    label: 'JUL',
  },
  {
    value: 'AUG',
    label: 'AUG',
  },
  {
    value: 'SEP',
    label: 'SEP',
  },
  {
    value: 'OCT',
    label: 'OCT',
  },
  {
    value: 'NOV',
    label: 'NOV',
  },
];

export const MonthsTransformer = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV'];

